import { render, staticRenderFns } from "./UpdateView.vue?vue&type=template&id=0c274d4d&"
import script from "./UpdateView.vue?vue&type=script&lang=js&"
export * from "./UpdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports